import { render, staticRenderFns } from "./MyClinicsPage.vue?vue&type=template&id=1a9d5a60&scoped=true"
import script from "./MyClinicsPage.vue?vue&type=script&lang=js"
export * from "./MyClinicsPage.vue?vue&type=script&lang=js"
import style0 from "./MyClinicsPage.vue?vue&type=style&index=0&id=1a9d5a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9d5a60",
  null
  
)

export default component.exports